<nz-layout>
  <nz-content>
    <lms-header></lms-header>
    <nz-divider></nz-divider>
    <div>
      <router-outlet></router-outlet>
    </div>
  </nz-content>
</nz-layout>
